import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';
import helpcenterimage from '../assets/images/logo_icon_white.svg';
import config from '../config/config';

const TransparencyCenter = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('Privacy');
  const [content, setContent] = useState('');
  const [links, setLinks] = useState([]);
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [metaKeywords, setMetaKeywords] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-safety-transparency-content`);
        if (response.data.success) {
          const pageContent = response.data.data['page-content'];
          setTitle(pageContent.title);
          setContent(pageContent.content);

          // Set SEO metadata
          const seo = response.data.data['page-seo'];
          setMetaTitle(seo.meta_title);
          setMetaDescription(seo.meta_description);
          setMetaKeywords(seo.meta_keyword);
        }
      } catch (error) {
        console.error('Failed to fetch content:', error);
      }
    };

    const fetchLinks = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-safety-transparency-links`);
        if (response.data.success) {
          setLinks(response.data.data);
        }
      } catch (error) {
        console.error('Failed to fetch links:', error);
      }
    };

    fetchContent();
    fetchLinks();
  }, []);

  useLayoutEffect(() => {
    // Update document head with SEO metadata
    document.title = metaTitle || 'Transparency Center';
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    const metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDescription || '');
    } else {
      const newMetaDescriptionTag = document.createElement('meta');
      newMetaDescriptionTag.name = 'description';
      newMetaDescriptionTag.content = metaDescription || '';
      document.head.appendChild(newMetaDescriptionTag);
    }

    if (metaKeywordsTag) {
      metaKeywordsTag.setAttribute('content', metaKeywords || '');
    } else {
      const newMetaKeywordsTag = document.createElement('meta');
      newMetaKeywordsTag.name = 'keywords';
      newMetaKeywordsTag.content = metaKeywords || '';
      document.head.appendChild(newMetaKeywordsTag);
    }
  }, [metaTitle, metaDescription, metaKeywords]);

  const handleLinkClick = (id) => {
    navigate(`/transparency-center/${id}`);
  };

  return (
    <div> 
      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/">
                <img src={staticlogo} alt="Logo" /> PatreonPass
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section id="help_search" className="help_search help_center_area">
        <div className="help_center">
            <img src={helpcenterimage} alt="Help Center" />
        </div>
        <div className="container">
          <div className="row">
            <div className="help_search_block">
              <h2 className="help_title">Patreon Pass Safety & Transparency Center</h2>        
            </div>
          </div>
        </div>
      </section>

      <section className="inner_static">
        <div className="container">
          <div className="row">
            <div className="page_title_header">{title}</div>
            <div className="page_content_static">
               <div dangerouslySetInnerHTML={{ __html: content }} />
              
               <ul className="page_links">
                  {links.map(link => (
                    <li key={link.id}>
                      <Link to={`/transparency-center/${link.id}`} onClick={() => handleLinkClick(link.id)}>
                        {link.title}
                      </Link>
                    </li>
                  ))}
               </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TransparencyCenter;
